import React from "react";
import PreloadIMAGES from "@insightfulscience/smart-react/PreloadImages";
import { array } from "prop-types";
import { publicConfig } from "../config";

const assetUrl = `${publicConfig.SB_CDN_HOST}${publicConfig.SB_CDN_BASE_URL}/assets`;

const PreloadImages = ({ imagesHref = [] }) => {
	return (
		<PreloadIMAGES
			host={assetUrl}
			imagesHref={[
				"/images/common/dotmatics-logo-white.svg",
				"/images/geneious/logo/logo-geneious.svg",
				...imagesHref,
			]}
		/>
	);
};

PreloadImages.propTypes = {
	// eslint-disable-next-line react/forbid-prop-types
	imagesHref: array,
};

export default PreloadImages;
